module.exports = __webpack_public_path__ + "4-80.jpg?a65fa47181f714a4e50820b158ea86ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-80.jpg
// module id = 161
// module chunks = 0